import styled from "@emotion/styled";
import HeaderPc from './Header/Header_Pc';
interface IPage {
  type?: string;
  children?: any;
  disable:boolean
}

const Layout = styled.div`
  width: 100%;
  /* min-height: 76vh; */
  height: 100%;
  display: block;
  overflow: hidden;
  position: relative;
  z-index: 1;
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
`

const PageWeb:React.FC<IPage> = ({ children, type, disable }) => {
  return (
    <Container>
      <HeaderPc disable={disable} />
      <Layout className={type}>{children}</Layout>
    </Container>
  )
};

export default PageWeb;